'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@/utils');

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'private-letter',
  props: {
    list: {
      type: Array
    },
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    index: {
      type: [Number, String],
      default: 0
    }
  },
  data: function data() {
    return {
      timeFormat: _utils.timeFormat,
      imagePath: _utils.imagePath
    };
  },

  components: {
    IconFont: _iconfont2.default
  },
  methods: {
    onClickItem: function onClickItem(item) {
      this.$router.push({
        path: '/notice-announcement/message-detail',
        query: {
          dialogueId: item.dialogueId,
          name: item.chatUserName || item.senderName
        }
      });
    }
  }
};